module.exports = __webpack_public_path__ + "img/Banner-slide-3.b9b6ac66.jpg";